import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class AccountOnboarding extends WebApi {
    async getAccountOnboardingCompanies({ page, per_page }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/account_onboarding/companies`, {
            'pagination[per_page]': per_page,
            'pagination[page]': page,
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    async getAccountOnboardingCompany(id) {
        const { data } = await axios.get(`${this.urlPrefix}/account_onboarding/companies/${id}`);
        return data;
    }
    async postAccountOnboardingCompany(company) {
        return axios.post(`${this.urlPrefix}/account_onboarding/companies`, { company });
    }
    async putAccountOnboardingCompany(company, id) {
        return axios.put(`${this.urlPrefix}/account_onboarding/companies/${id}`, { company });
    }
    async changeCompanyData(company, id) {
        return axios.put(`${this.urlPrefix}/companies/${id}`, { company });
    }
    async deleteAccountOnboardingCompany(id) {
        return axios.delete(`${this.urlPrefix}/account_onboarding/companies/${id}`);
    }
}
const accountOnboarding = new AccountOnboarding();
export { accountOnboarding as AccountOnboarding, };
